export function isColorized(state) {
  return state.colorize;
}
export function isColorLegendShown(state) {
  return state.showColorLegend;
}